<template>
  <div class="widget-mask" @mousedown.self.stop="closeDialogWidget">
    <div class="widget" @click.stop="closeAllPopups">
      <!--класс slide-out используется только в мобильной верстке, чтобы скрыть меню выбора диалога-->
      <div v-show="!selectResendUserMode" class="aside" :class="currentDialog ? 'slide-out' : ''">
        <div class="aside__close-dialog"
            v-if="mediaBreakpoint !== 'desktop'"
            @click.stop="closeDialogWidget"
        >
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <div class="aside__head">
          <SearchForm borderless
                      :value="dialogRoomList.searchValue"
                      placeholder="Поиск контактов"
                      @form-submit="setDialogListSearchValue"
          />
        </div>
        <div class="aside__body" ref="aside_body">
          <DialogRoomList :state="dialogRoomList"
                          :current-dialog-id="currentDialog ? currentDialog.id : null"
                          @set-active-dialog="setActiveDialog"
                          @create-private-dialog="createPrivatDialog"
          />
          <transition name="fade">
            <ThePagePreloader v-if="dialogRoomList.isLoading"
                              position="component"
            />
          </transition>
        </div>
        <div class="aside__bottom">
          <div class="create-button"
              v-if="roleAccessDialogCreate"
              @click.stop="showDialogRoomModal(null)"
          >
            <span class="create-button__icon">
              <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.9668 14.813L18.2988 14.472L18.1389 14.7852L18.2774 15.1084L18.9668 14.813ZM15.9801 18.261L16.2173 17.5495L15.857 17.4294L15.547 17.6487L15.9801 18.261ZM21.1886 19.9971L20.9514 20.7087L22.5358 21.2368L21.878 19.7017L21.1886 19.9971ZM19.25 10.5C19.25 11.9316 18.9068 13.2808 18.2988 14.472L19.6348 15.1539C20.3481 13.7565 20.75 12.1741 20.75 10.5H19.25ZM10.5 1.75C15.3325 1.75 19.25 5.66751 19.25 10.5H20.75C20.75 4.83908 16.1609 0.25 10.5 0.25V1.75ZM1.75 10.5C1.75 5.66751 5.66751 1.75 10.5 1.75V0.25C4.83908 0.25 0.25 4.83908 0.25 10.5H1.75ZM10.5 19.25C5.66751 19.25 1.75 15.3325 1.75 10.5H0.25C0.25 16.1609 4.83908 20.75 10.5 20.75V19.25ZM15.547 17.6487C14.1211 18.6574 12.3808 19.25 10.5 19.25V20.75C12.7012 20.75 14.7423 20.0553 16.4133 18.8733L15.547 17.6487ZM15.743 18.9725L20.9514 20.7087L21.4258 19.2856L16.2173 17.5495L15.743 18.9725ZM21.878 19.7017L19.6562 14.5175L18.2774 15.1084L20.4992 20.2926L21.878 19.7017Z" fill="currentColor"/>
                <path d="M10.875 6L10.875 15" stroke="currentColor" stroke-width="2"/>
                <path d="M15.375 10.5L6.375 10.5" stroke="currentColor" stroke-width="2"/>
              </svg>
            </span>
            Групповой чат
          </div>
        </div>
      </div>

      <div class="body">
        <transition name="fade">
          <div class="head" v-if="currentDialog">
            <!--кнопка назад к выбору диалога появляется только на мобилке-->
            <div class="head__close-dialog"
                 v-if="mediaBreakpoint !== 'desktop' && currentDialog"
                 @click.stop="removeActiveDialog"
            >
              <svg class="arrow-prev-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.023 7.96802L1.99946 8.04702M1.99946 8.04702L7.22547 2.97317M1.99946 8.04702L7.3552 13.5634"
                  stroke-width="1.5"/>
              </svg>
            </div>
            <div class="dialog">
              <div class="dialog__avatar user-avatar">
                <div class="dialog__group-avatar" :style="`background: ${currentDialog.color}`" v-if="currentDialog.is_group">
                  <div class="dialog__group-avatar__icon">
                    <svg width="19" height="13" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.578 3.83416C17.578 5.27849 16.3678 6.44934 14.8749 6.44934C13.382 6.44934 12.1717 5.27849 12.1717 3.83416C12.1717 2.38984 13.382 1.21898 14.8749 1.21898C16.3678 1.21898 17.578 2.38984 17.578 3.83416ZM18.838 3.83416C18.838 5.3158 17.9694 6.60116 16.6978 7.23953C17.8624 7.59073 18.896 8.27178 19.6617 9.19962C20.3529 10.0372 20.793 11.0363 20.9427 12.0882H21V13.3072H12.1045C12.1404 13.4639 12.1697 13.622 12.1924 13.781H12.2497V14.5871V14.5901V15H0V14.5901V13.781H0.0573702C0.128603 13.2811 0.265722 12.7909 0.466228 12.3225C0.774031 11.6036 1.22519 10.9504 1.79393 10.4002C2.36268 9.84993 3.03788 9.41346 3.78098 9.11567C3.95197 9.04715 4.12578 8.98629 4.30187 8.93317C3.03027 8.29483 2.16151 7.00943 2.16151 5.52772C2.16151 3.41017 3.93587 1.69356 6.12466 1.69356C8.31345 1.69356 10.0878 3.41017 10.0878 5.52772C10.0878 7.00937 9.21913 8.29472 7.94761 8.9331C8.12379 8.98623 8.29768 9.04712 8.46876 9.11567C8.89639 9.28704 9.30154 9.50433 9.67685 9.76281C10.2865 8.81627 11.1628 8.05132 12.2088 7.56198C12.4826 7.43388 12.7645 7.32633 13.0521 7.23961C11.7805 6.60126 10.9117 5.31586 10.9117 3.83416C10.9117 1.71661 12.6861 0 14.8749 0C17.0637 0 18.838 1.71661 18.838 3.83416ZM11.677 12.0882H19.7133C19.5733 11.304 19.2309 10.5618 18.7121 9.93304C18.0176 9.09141 17.0481 8.50309 15.9625 8.26457C14.877 8.02604 13.7399 8.15147 12.7378 8.62028C11.8389 9.04079 11.0964 9.71518 10.6059 10.5506C11.0442 11.0057 11.4056 11.5246 11.677 12.0882ZM8.82782 5.52772C8.82782 6.97205 7.61758 8.1429 6.12466 8.1429C4.63175 8.1429 3.4215 6.97205 3.4215 5.52772C3.4215 4.0834 4.63175 2.91254 6.12466 2.91254C7.61758 2.91254 8.82782 4.0834 8.82782 5.52772ZM11.0426 13.781H1.20719C1.26962 13.4259 1.37311 13.0777 1.51629 12.7433C1.76697 12.1578 2.13441 11.6258 2.59761 11.1777C3.06082 10.7296 3.61072 10.3741 4.21593 10.1316C4.82114 9.88903 5.4698 9.7642 6.12487 9.7642C6.77994 9.7642 7.4286 9.88903 8.03381 10.1316C8.63902 10.3741 9.18892 10.7296 9.65213 11.1777C10.1153 11.6258 10.4828 12.1578 10.7335 12.7433C10.8766 13.0777 10.9801 13.4259 11.0426 13.781Z" fill="currentColor"/>
                    </svg>
                  </div>
                </div>
                <div
                  class="dialog__private-avatar"
                  style="cursor:pointer"
                  v-else
                  @click="$router.push(`/user/info/${getCompanionId(currentDialog.users)}/personal`)"
                >
                  <img v-if="getDialogAvatar(getCompanionId(currentDialog.users))"
                       :src="getDialogAvatar(getCompanionId(currentDialog.users)).url" :alt="currentDialog.name">
                  <img v-else src="/img/avatar-thumb.png" :alt="currentDialog.name">
                </div>
              </div>

              <!-- информация диалога -->
              <div class="dialog__info" v-if="currentDialog.is_group">
                <div class="dialog__name">{{ currentDialog.name }}</div>
                <div @click="openUsersModals" class="dialog__members">участников: {{ currentDialog.users.length }}</div>

                <div
                  v-if="usersGroupModal"
                  class="dialog__members-modal"
                  tabindex="-1"
                  @focusout="handleBlur"
                  ref="usersGroupModal"
                >
                  <SearchForm
                    :value="userGroupSearch"
                    placeholder="Поиск по участникам"
                    @form-submit="(val) => userGroupSearch = val"
                    :dynamic="true"
                  />
                  <div class="users">
                    <div
                      v-for="(user, index) in userGroupList"
                      :key="'groupUser' + index"
                      class="users__item"
                      @click="$router.push(`/user/info/${user.id}/personal`)"
                    >
                      <div class="dialog__avatar user-avatar">
                        <img v-if="getUserAvatar(user.id)" :src="getUserAvatar(user.id).url">
                        <img v-else src="/img/avatar-thumb.png">
                      </div>
                      <div v-if="getUserName(user.id)">{{ getUserName(user.id).split(" ").slice(0, 2).reverse().join(" ") }}</div>
                    </div>
                  </div>
                </div>

              </div>
              <div
                class="dialog__info"
                style="cursor:pointer"
                @click="$router.push(`/user/info/${getCompanionId(currentDialog.users)}/personal`)"
                v-else
              >
                <div class="dialog__name">{{ getDialogName(getCompanionId(currentDialog.users)) }}</div>
                <div class="dialog__position">{{ getUserPosition(getCompanionId(currentDialog.users)) }}</div>
              </div>

            </div>
            <div class="dialog-controls">
              <!--добавление и удаление учатников происходит через редактирование комнаты-->
              <!--<div class="dialog-controls__item invite">
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.3457 0.911133L10.3457 22.4653" stroke="currentColor" stroke-width="2"/>
                  <path d="M21.5537 12.1191L-0.000478983 12.1191" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>-->

              <transition name="fade">
                <span style="display: flex">
                  <button v-if="selectMode" class="resend" @click="selectResendUserMode = true">
                    Переслать
                  </button>
                  <button v-if="selectMode" class="resend" @click="clearResend">
                    Отмена
                  </button>
                </span>
              </transition>

              <div class="dialog-controls__item history" @click.stop="showDialogHistoryModal">
                <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="path-22-inside-22" fill="white">
                    <path d="M23.2785 13.3629C23.2785 15.6649 22.5959 17.9153 21.317 19.8293C20.038 21.7434 18.2202 23.2352 16.0934 24.1162C13.9666 24.9971 11.6264 25.2276 9.36856 24.7785C7.11076 24.3294 5.03684 23.2209 3.40906 21.5931C1.78128 19.9653 0.672749 17.8914 0.223645 15.6336C-0.225458 13.3758 0.00503789 11.0355 0.885986 8.90874C1.76693 6.78195 3.25877 4.96414 5.17283 3.6852C7.0869 2.40626 9.33723 1.72363 11.6393 1.72363V3.28681C9.6464 3.28681 7.69829 3.87776 6.04129 4.98493C4.38428 6.09211 3.09281 7.66578 2.33017 9.50694C1.56754 11.3481 1.368 13.3741 1.75678 15.3286C2.14557 17.2832 3.10523 19.0786 4.51439 20.4878C5.92356 21.8969 7.71895 22.8566 9.67352 23.2454C11.6281 23.6342 13.654 23.4346 15.4952 22.672C17.3364 21.9094 18.91 20.6179 20.0172 18.9609C21.1244 17.3039 21.7153 15.3558 21.7153 13.3629H23.2785Z"/>
                  </mask>
                  <path d="M23.2785 13.3629C23.2785 15.6649 22.5959 17.9153 21.317 19.8293C20.038 21.7434 18.2202 23.2352 16.0934 24.1162C13.9666 24.9971 11.6264 25.2276 9.36856 24.7785C7.11076 24.3294 5.03684 23.2209 3.40906 21.5931C1.78128 19.9653 0.672749 17.8914 0.223645 15.6336C-0.225458 13.3758 0.00503789 11.0355 0.885986 8.90874C1.76693 6.78195 3.25877 4.96414 5.17283 3.6852C7.0869 2.40626 9.33723 1.72363 11.6393 1.72363V3.28681C9.6464 3.28681 7.69829 3.87776 6.04129 4.98493C4.38428 6.09211 3.09281 7.66578 2.33017 9.50694C1.56754 11.3481 1.368 13.3741 1.75678 15.3286C2.14557 17.2832 3.10523 19.0786 4.51439 20.4878C5.92356 21.8969 7.71895 22.8566 9.67352 23.2454C11.6281 23.6342 13.654 23.4346 15.4952 22.672C17.3364 21.9094 18.91 20.6179 20.0172 18.9609C21.1244 17.3039 21.7153 15.3558 21.7153 13.3629H23.2785Z" stroke="currentColor" stroke-width="4" mask="url(#path-22-inside-22)"/>
                  <path d="M11.208 8.62109V14.6563H17.2432" stroke="currentColor" stroke-width="2"/>
                  <path d="M15.7344 2.61331L11.208 5.22661L11.208 -1.97854e-07L15.7344 2.61331Z" fill="currentColor"/>
                </svg>
              </div>

              <div v-if="isAdmin"
                   class="dialog-controls__item menu"
                   :class="currentDialog.isControlsActive ? 'active' : ''"
                   @click.stop="toggleCurrentDialogControls"
              >
                <svg width="3" height="24" viewBox="0 0 3 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor"/>
                  <circle cx="1.5" cy="11.7842" r="1.5" fill="currentColor"/>
                  <circle cx="1.5" cy="22.0684" r="1.5" fill="currentColor"/>
                </svg>
                <transition name="fade">
                  <div class="menu__popup" v-if="currentDialog.isControlsActive">
                    <AppPopupMenu :items="{ update: currentDialog.is_group, remove: true }"
                                  @update-item="showDialogRoomModalForUpdate"
                                  @remove-item="showDialogModalForDelete"
                    />
                    <!--
                    @remove-item="removeDialog"
                    -->
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div class="pinned"
               v-if="currentDialog && currentDialog.pinned_message"
               @click.prevent="showPinnedModal"
          >
            <div class="pinned__title">
              <span class="pinned__icon">
                <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.27562 5.39689L5.60838 3.37356L6.25941 2.92648C6.46386 2.78607 6.49527 2.47665 6.32956 2.23535L5.72949 1.36156C5.56378 1.12027 5.26372 1.03849 5.05926 1.17889L0.863777 4.06013C0.659324 4.20053 0.627915 4.50995 0.793622 4.75125L1.39369 5.62504C1.5594 5.86633 1.85947 5.94811 2.06392 5.80771L2.71495 5.36062L4.00474 7.64315C3.53848 8.56753 3.46617 9.70057 4.10049 10.6242C4.26619 10.8655 4.56626 10.9473 4.77071 10.8069L6.86846 9.36628L8.1687 11.2596C8.18423 11.2822 8.204 11.3015 8.22646 11.3158L9.19672 11.9354C9.31562 12.0113 9.44568 11.9223 9.41747 11.7838L9.18759 10.6558C9.18226 10.6296 9.17141 10.6043 9.15589 10.5817L7.85565 8.68833L9.95339 7.24771C10.1578 7.10731 10.1893 6.79789 10.0235 6.55659C9.38367 5.62487 8.29479 5.29473 7.27562 5.39689Z" fill="currentColor"/>
                </svg>
              </span>
              Посмотреть закрепленное сообщение
              <span class="pinned__unpin" title="Открепить сообщение" @click.stop="unPinMessage">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L13 13" stroke="currentColor" stroke-width="2"/>
                  <path d="M1 13L13 1" stroke="currentColor" stroke-width="2"/>
                </svg>
              </span>
            </div>
            <div class="pinned__row">
              <div class="pinned__files" v-if="currentDialog.pinned_message.attachments">
                <svg width="25" height="35" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.70187 17.3854C4.34186 16.5356 3.24 13.9667 4.20612 11.6493L7.65684 3.37216C8.38585 1.6234 10.4293 0.717392 12.2149 1.35158C13.983 1.97956 14.8285 3.88268 14.1056 5.61663L11.0954 12.8271C10.6043 14.0051 9.21554 14.6074 8.0205 14.1588C6.86919 13.7267 6.34145 12.4668 6.81556 11.3296L9.18256 5.66264C9.28436 5.41895 9.57048 5.28872 9.82162 5.37177L10.7309 5.67245C10.9821 5.75551 11.1031 6.02041 11.0013 6.26409L8.63462 11.9304C8.55348 12.1251 8.64253 12.3492 8.82936 12.4194C9.00738 12.4862 9.20325 12.4018 9.27633 12.2264L12.2865 5.01597C12.6091 4.24204 12.2286 3.38357 11.438 3.10278C10.6649 2.82825 9.79197 3.21492 9.47617 3.97246L6.02541 12.2496C5.45355 13.6214 6.10899 15.141 7.48662 15.637C8.86031 16.1316 10.4204 15.4414 10.9809 14.0969L13.8115 7.30741C13.9131 7.06365 14.1991 6.93326 14.4503 7.01614L15.3599 7.31622C15.6111 7.3991 15.7324 7.6639 15.6308 7.90768L12.8003 14.6972C11.8202 17.048 9.07795 18.2409 6.70187 17.3854Z" fill="currentColor"/>
                </svg>
              </div>
              <p class="pinned__text" v-if="currentDialog.pinned_message.message">
                <span class="pinned__text-inner plain-html" v-html="currentDialog.pinned_message.message.length < 190 ? currentDialog.pinned_message.message : `${currentDialog.pinned_message.message.slice(0, 190)}...`"></span>
              </p>
            </div>
          </div>
        </transition>

        <div class="messages-wrap" ref="messages_wrap">
          <!-- загрузка активного диалога -->
          <ThePagePreloader v-if="dialogRoomLoading || (currentDialog && currentDialog.messagesIsLoading)" position="component" />

          <!-- подгрузка старых сообщений при прокрутки -->
          <ThePagePreloader
            v-if="dialogNextPageIsLoading"
            position="component"
            class="messages-wrap__preloader"
          />

          <!-- сообщения -->
          <transition name="fade" mode="out-in">
            <div class="message-list" v-if="currentDialog && !dialogRoomLoading && !currentDialog.messagesIsLoading && currentDialog.messages && currentDialog.messages.length">
              <transition-group name="fade">
                <div class="message-list__item" v-for="item in currentDialog.messages" :key="item.id">
                  <!-- в массив сообщений помещается отбивка по дате (во время записи в стейт) -->
                  <div class="date" v-if="item.is_dateBreaker">
                    <h4 class="date__h">{{ dateBreakerText(item.date) }}</h4>
                  </div>
                  <DialogMessage v-else
                                 :message="item"
                                 :selectMode="selectMode"
                                 :isSelected="isSelected(item)"
                                 @toggle-controls="toggleMessageControls"
                                 @select-message="selectMessage"
                                 @pin-message="pinMessage"
                                 @update-message="updateMessage"
                                 @reply-message="replyMessage"
                                 @make-task="makeTaskFromMessage"
                                 @remove-message="removeMessage"
                  />
                </div>
              </transition-group>
            </div>
            <div class="messages-wrap__no-records" v-if="!currentDialog && !dialogRoomLoading">
              <AppNoRecordsPlaceholder  text="Выберите диалог" />
            </div>
            <div class="messages-wrap__no-records" v-if="currentDialog && !dialogRoomLoading && !currentDialog.messagesIsLoading && currentDialog.messages.length === 0">
              <AppNoRecordsPlaceholder  text="В этом диалоге нет сообщений" />
            </div>
          </transition>
        </div>

        <transition name="fade">
          <div class="message-area-wrap" v-if="currentDialog">
            <div class="message-area-info">
              <div class="message-area-error">
                <transition name="fade">
                  <div class="message-area-error__inner" v-if="messageArea.errorMessage">
                    <div class="message-area-error__icon">
                      <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM13.944 13.92L14.264 6.912H11.576L11.896 13.92H13.944ZM13.944 15.808C13.6667 15.52 13.3253 15.376 12.92 15.376C12.5253 15.376 12.184 15.52 11.896 15.808C11.6187 16.0853 11.48 16.4213 11.48 16.816C11.48 17.2213 11.6187 17.568 11.896 17.856C12.184 18.1333 12.5253 18.272 12.92 18.272C13.3253 18.272 13.6667 18.1333 13.944 17.856C14.232 17.568 14.376 17.2213 14.376 16.816C14.376 16.4213 14.232 16.0853 13.944 15.808Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div class="message-area-error__message">
                      {{ messageArea.errorMessage }}
                    </div>
                  </div>
                </transition>
              </div>

              <div class="who-prints">
                <transition name="fade">
                  <div class="who-prints__inner" v-if="currentDialog.whoPrintsId && currentDialog.whoPrintsId !== currentUser.id">
                    {{ getUserName(currentDialog.whoPrintsId) }} печатает
                    <div class="who-prints__icon">
                      <span class="dot"></span>
                      <span class="dot"></span>
                      <span class="dot"></span>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="message-area">
              <div class="message-area__attachment-preview" v-if="messageArea.attachment.files.length !== 0 || messageArea.attachment.tags.length !== 0">
                <AppMessageAttachmentPreview :files="messageArea.attachment.files"
                                             :tags="messageArea.attachment.tags"
                                             :editable="true"
                                             @remove-file="removeFile"
                                             @remove-tag="removeTag"
                />
              </div>
              <div class="message-area__inner">
                <div class="message-area__attachment">
                  <AppMessageAttachment :link-tooltip="messageArea.attachment.linkTooltip"
                                        :tag-tooltip="messageArea.attachment.tagTooltip"
                                        :allow-inputs="messageAttachmentInputs"
                                        @toggle-link-tooltip="toggleLinkTooltip"
                                        @close-link-tooltip="closeLinkTooltip"
                                        @set-link-url="setLinkUrl"
                                        @toggle-tag-tooltip="toggleTagTooltip"
                                        @close-tag-tooltip="closeTagTooltip"
                                        @set-tag-text="setTagText"
                                        @attach-files="attachFiles"
                                        @attach-link="attachLink"
                                        @attach-tag="attachTag"
                                        @clear-validation="clearAttachmentValidation"
                  />
                </div>
                <div class="message-area__input custom-scrollbar">

                  <div class="reply-wrap" v-if="messageArea.reply.id !== null && !messageArea.resendMessages.length">
                    <div class="replied-to">
                    <span class="replied-to__close" @click.stop="unReplyMessage">
                      <svg class="close-icon" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L12 12" stroke="currentColor" stroke-width="2"/>
                        <path d="M1 12L12 1" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </span>
                      {{ getUserName(messageArea.reply.ownerId) }},
                    </div>
                    <div class="quote" v-if="messageArea.reply.quote">
                      "<span class="plain-html" v-html="messageArea.reply.quote.length < 200 ? messageArea.reply.quote : `${messageArea.reply.quote.slice(0, 200)}...`"></span>"
                    </div>
                  </div>

                  <div v-if="messageArea.resendMessages.length" class="message-area__input-resend">
                    <b>Пересланные сообщения</b>
                    <br>{{ messageArea.resendMessages.length }} {{ declensionsWord }}
                    <span class="resend-clear" @click.stop="$store.commit('SET_DIALOG_RESEND_MESSAGES', [])">
                      <svg class="close-icon" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L12 12" stroke="currentColor" stroke-width="2"/>
                        <path d="M1 12L12 1" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </span>
                  </div>

                  <AppMessageInput :value="messageArea.message"
                                   placeholder="Написать сообщение"
                                   textarea-height="auto"
                                   :disabled="sendMessageLoading"
                                   blurAfterSend
                                   @got-focus="messageAreaInputFocused"
                                   @value-changed="setMessageValue"
                                   @selection-range="setInputSelectionRange"
                                   @send-message="sendMessage"
                                   @paste-files="attachFiles"
                  />
                </div>
                <div class="message-area__buttons">
                  <transition name="fade">
                    <div class="message-area__cancel-button"
                         v-if="messageArea.updatedId"
                         @click.stop="cancelUpdate"
                    >
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.16895 6.67871L20.5273 21.0162" stroke="currentColor" stroke-width="2"/>
                        <path d="M21.0166 7.16895L6.67913 20.5273" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </div>
                  </transition>
                  <button
                    class="message-area__send-button"
                    :disabled="sendBtnDisabled || sendMessageLoading"
                    @click="sendMessage"
                  >
                    <svg width="27" height="29" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        :fill="sendMessageLoading || sendBtnDisabled ? '#c4c4c4' : 'currentColor'"
                        d="M26.6148 15.0367L0.0258203 28.3882L7.37489 15.0176L0.379016 0.0524299L26.6148 15.0367Z"
                      />
                    </svg>
                  </button >
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <!--Добавить чат-->
      <transition name="fade">
        <DialogRoomModal
          v-if="dialogRoomModal.active"
          :state="dialogRoomModal"
          :users="usersListForChats"
          @add-member="addDialogRoomModalMember"
          @remove-member="removeDialogRoomModalMember"
          @save-info="saveDialogRoomInfo"
          @close-modal="closeDialogRoomModal"
        />
      </transition>
      <!-- /модалка Добавить чат-->

      <!-- Модалка удаления чата -->
      <transition name="fade">
        <DialogDeleteModal
          v-if="dialogDeleteModal.active"
          :items="{ remove: true }"
          :state="dialogDeleteModal"
          @close-modal="closeDialogDeleteModal"
          @remove-item="removeDialog"
        />
      </transition>
      <!-- /модалка удаления чата -->

      <!--модалка истории сообщений-->
      <transition name="fade">
        <DialogHistoryModal v-if="dialogHistoryModal.active"
                            :state="dialogHistoryModal"
                            @close-modal="closeDialogHistoryModal"
        />
      </transition>
      <!--/модалка истории сообщений-->

      <!--модалка закрепленного сообщения-->
      <transition name="fade">
        <DialogPinnedModal v-if="dialogPinnedModal.active"
                           :state="dialogPinnedModal"
                           @close-modal="closeDialogPinnedModal"
        />
      </transition>
      <!--модалка закрепленного сообщения-->

      <!-- модалка выбора пересланного сообщения  -->
      <Modal
        v-if="selectResendUserMode"
        @close="selectResendUserMode = false"
        background="#F3F5FF"
        border-radius="0px"
        height="500px"
        width="500px"
        only-modal
      >
        <div class="modal__head" style="margin-bottom: 0">
          <h3 class="modal__title">Переслать сообщения</h3>
          <div class="close" @click.stop="selectResendUserMode = false">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L16 16" stroke="currentColor" stroke-width="2" />
              <path d="M1 16L16 1" stroke="currentColor" stroke-width="2" />
            </svg>
          </div>
        </div>
        <SearchForm
          borderless
          :value="dialogRoomList.searchValue"
          placeholder="Поиск контактов"
          @form-submit="setDialogListSearchValue"
          style="padding: 6px 0; margin-bottom: 6px"
        />
        <DialogRoomList
          :state="dialogRoomList"
          :current-dialog-id="currentDialog ? currentDialog.id : null"
          @set-active-dialog="setActiveDialog"
          @create-private-dialog="createPrivatDialog"
        />
      </Modal>

      <!-- Добавить чат  -->
<!--      <transition name="fade">-->
<!--        <BaseModal-->
<!--          v-if="modalVisible"-->
<!--          @close="modalVisible = false"-->
<!--          title="Создать чат"-->
<!--        >-->
<!--          <AddedChat @cancel="modalVisible = false"-->
<!--          />-->
<!--        </BaseModal>-->
<!--      </transition>-->
    </div>
  </div>
</template>

<script>
import AppMessageInput from '@/components/page/input/AppMessageInput'
import AppMessageAttachment from '@/components/page/input/AppMessageAttachment'
import DialogMessage from './DialogMessage'
import DialogRoomList from './DialogRoomList'
import SearchForm from '@/components/page/input/SearchForm'
import AppPopupMenu from '@/components/page/popup/AppPopupMenu'
import AppMessageAttachmentPreview from '@/components/page/input/AppMessageAttachmentPreview'
import DialogRoomModal from '@/components/page/widget/DialogRoomModal'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import { formatDate, currentDate } from '@/utils/utils'
import DialogHistoryModal from '@/components/page/widget/DialogHistoryModal'
import DialogPinnedModal from '@/components/page/widget/DialogPinnedModal'
import Modal from '@/components/page/modal/base/Modal'
import DialogDeleteModal from '@/components/page/widget/DialogDeleteModal'
import Preloader from '@/components/page/Preloader'
import BaseModal from '../modal/base/BaseModal'
import { mapGetters } from 'vuex'

export default {
  name: 'DialogWidget',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BaseModal,
    DialogDeleteModal,
    DialogPinnedModal,
    DialogHistoryModal,
    AppNoRecordsPlaceholder,
    ThePagePreloader,
    DialogRoomModal,
    AppMessageAttachmentPreview,
    AppPopupMenu,
    SearchForm,
    DialogRoomList,
    DialogMessage,
    AppMessageAttachment,
    AppMessageInput,
    Modal,
    // eslint-disable-next-line vue/no-unused-components
    Preloader
  },

  data () {
    return {
      // для хранения ссылки на текущий инпут сообщения и его выделенной области
      messageInput: null,
      inputSelectionRange: null,
      // окно сообщений
      messagesWrap: {
        elem: null,
        scrollHeightA: null,
        scrollHeightB: null
      },
      asideBody: null,

      selectedMessages: [],
      selectMode: false,
      selectResendUserMode: false,

      usersGroupModal: false,
      userGroupSearch: '',
      userGroupList: [],

      modalVisible: true
    }
  },

  computed: {
    ...mapGetters({
      sendBtnDisabled: 'getSendButtonDisabled'
    }),
    currentDialog () {
      return this.$store.getters.getCurrentDialog
    },
    isAdmin () {
      return this.currentUser.id === this.currentDialog.owner_id || this.currentDialog.admins?.some(admin => admin.id === this.currentUser.id)
    },
    roleAccessDialogCreate () {
      return this.$store.getters.getRoleRightsDialogs.roomActions.add
    },
    dialogNextPageIsLoading () {
      return this.$store.getters.getDialogNextPageIsLoading
    },
    dialogRoomLoading () {
      return this.$store.getters.getDialogRoomLoading
    },
    dialogRoomList () {
      return this.$store.getters.getDialogRoomList
    },
    // это вычисляемое свойство нужно чтобы повесить watcher непосредственно на массив сообщений
    messages () {
      return this.$store.getters.getDialogMessages
    },
    pinned () {
      return this.$store.getters.getPinnedMessage
    },
    messageArea () {
      return this.$store.getters.getDialogMessageArea
    },
    messageAttachmentInputs () {
      return this.mediaBreakpoint !== 'desktop'
        ? { files: true, links: false, tags: false }
        : { files: true, links: true, tags: false }
    },
    usersListForChats () {
      return this.$store.getters['[dictionaries] usersListForChats']
    },
    dialogRoomModal () {
      return this.$store.getters.getDialogRoomModal
    },
    dialogDeleteModal () {
      return this.$store.getters.getDialogDeleteModal
    },
    dialogHistoryModal () {
      return this.$store.getters.getDialogHistoryModal
    },
    dialogPinnedModal () {
      return this.$store.getters.getDialogPinnedModal
    },
    dialogAutoScroll () {
      return this.$store.getters.getDialogMessagesWrapAutoScroll
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    sendMessageLoading () {
      return this.$store.getters.getSendMessageLoading
    },
    declensionsWord () {
      const count = this.messageArea.resendMessages.length
      const modulo = count % 10
      if (count > 10 && count < 20) { return 'сообщений' }
      if (modulo > 1 && modulo < 5) { return 'сообщения' }
      if (modulo === 1) { return 'сообщение' }
      return 'сообщений'
    }
  },

  methods: {
    closeDialogDeleteModal () {
      this.$store.commit('CLOSE_DIALOG_DELETE_MODAL')
    },

    toggleCurrentDialogControls () {
      this.$store.dispatch('toggleCurrentDialogControls')
    },
    closeDialogWidget () {
      this.$store.dispatch('closeDialogWidget')
    },
    closeAllPopups () {
      this.$store.dispatch('closeAllDialogWidgetPopups')
    },
    toggleMessageControls (messageId) {
      this.$store.dispatch('toggleDialogMessageControls', messageId)
    },
    messageAreaInputFocused () {
      this.$store.commit('CLEAR_DIALOG_MESSAGE_AREA_ERROR')
      this.$store.dispatch('setDialogMessageListIsRead')
    },
    setMessageValue (message) {
      this.$store.dispatch('setDialogMessageValue', message)
    },
    attachFiles (files) {
      this.$store.dispatch('dialogMessageAttachFiles', files)
    },
    removeFile (data) {
      this.$store.dispatch('dialogMessageRemoveFile', data)
    },
    toggleLinkTooltip () {
      this.$store.dispatch('dialogMessageToggleLinkTooltip')
      const range = this.inputSelectionRange
      if (range) {
        this.$store.dispatch('dialogMessageSetLinkText', range.toString())
      } else {
        this.$store.dispatch('dialogMessageSetLinkText', '')
      }
    },
    closeLinkTooltip () {
      this.$store.dispatch('dialogMessageCloseLinkTooltip')
    },
    setInputSelectionRange (data) {
      this.messageInput = data.input

      // берем Range если не пустой, проверяем на наличие вложенных тегов (иначе обертывание в ссылку ломается), может быть undefined если выделено одно слово.
      if (!data.range.collapsed && (data.range.commonAncestorContainer.childElementCount === undefined || data.range.commonAncestorContainer.childElementCount === 0)) {
        this.inputSelectionRange = data.range
      } else {
        this.inputSelectionRange = null
      }
    },
    setLinkUrl (url) {
      this.$store.dispatch('dialogMessageSetLinkUrl', url)
    },
    attachLink () {
      const range = this.inputSelectionRange
      const url = this.messageArea.attachment.linkTooltip.url.indexOf('https://') + 1 ? this.messageArea.attachment.linkTooltip.url : `https://${this.messageArea.attachment.linkTooltip.url}`

      if (range && this.messageArea.attachment.linkTooltip.url.length !== 0) {
        const linkTag = document.createElement('a')
        linkTag.setAttribute('target', '_blank')
        linkTag.setAttribute('title', url)
        linkTag.setAttribute('href', url)
        range.surroundContents(linkTag)
      }
      this.$store.dispatch('setDialogMessageValue', this.messageInput.innerHTML)
      this.$store.dispatch('dialogMessageAttachLink')
    },
    toggleTagTooltip () {
      this.$store.dispatch('dialogMessageToggleTagTooltip')
    },
    closeTagTooltip () {
      this.$store.dispatch('dialogMessageCloseTagTooltip')
    },
    setTagText (text) {
      this.$store.dispatch('dialogMessageSetTagText', text)
    },
    attachTag () {
      this.$store.dispatch('dialogMessageAttachTag')
    },
    removeTag (index) {
      this.$store.dispatch('dialogMessageRemoveTag', index)
    },
    clearAttachmentValidation () {
      this.$store.dispatch('dialogMessageAttachmentClearValidation')
    },
    sendMessage () {
      if (!this.sendMessageLoading) {
        this.$store.dispatch('sendDialogMessage')
      }
    },
    selectMessage (message) {
      const selectIndex = this.selectedMessages.findIndex(selsected => selsected === message)

      if (selectIndex !== -1) {
        this.$delete(this.selectedMessages, selectIndex)
      } else {
        this.selectedMessages.push(message)
        this.selectedMessages = this.selectedMessages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
      }
    },
    isSelected (message) {
      return this.selectedMessages.some(selected => selected === message)
    },
    resend () {
      this.$store.commit('SET_DIALOG_RESEND_MESSAGES', this.selectedMessages)
      this.clearResend()
    },
    clearResend () {
      this.selectedMessages = []
      this.selectMode = false
    },
    pinMessage (messageId) {
      this.$store.dispatch('pinDialogMessage', messageId)
    },
    unPinMessage () {
      this.$store.dispatch('unPinDialogMessage')
    },
    updateMessage (message) {
      this.$store.dispatch('getDialogMessageForUpdate', message)
    },
    replyMessage (data) {
      this.$store.commit('SET_DIALOG_RESEND_MESSAGES', [])
      this.$store.dispatch('replyDialogMessage', data)
    },
    unReplyMessage () {
      this.$store.dispatch('unReplyDialogMessage')
    },
    cancelUpdate () {
      this.$store.dispatch('cancelDialogMessageUpdate')
    },
    makeTaskFromMessage (messageId) {},
    removeMessage (messageId) {
      this.$store.dispatch('removeDialogMessage', messageId)
    },
    setDialogListSearchValue (value) {
      this.$store.dispatch('setDialogListSearchValue', value)
    },
    setActiveDialog (roomId) {
      this.$store.dispatch('setActiveDialog', roomId)

      if (roomId === this.currentDialog?.id) {
        this.checkResend()
      }
    },
    removeActiveDialog () {
      this.$store.commit('REMOVE_ACTIVE_DIALOG_ROOM')
    },
    removeDialog (value) {
      console.log('value', value)
      const dialogData = {
        id: this.currentDialog.id,
        users: this.currentDialog.users.map(user => user.id)
      }
      this.$store.dispatch('removeDialog', dialogData)
    },
    createPrivatDialog (user) {
      this.$store.dispatch('createPrivateDialog', user)
    },

    // модалка удаления чата
    showDialogDeleteModal (roomId) {
      this.$store.dispatch('showDialogDeleteModal', roomId)
    },
    // модалка комнаты чата
    showDialogRoomModal (roomId) {
      this.$store.dispatch('showDialogRoomModal', roomId)
    },
    showDialogModalForDelete () {
      this.toggleCurrentDialogControls()
      this.showDialogDeleteModal(this.currentDialog.id)
    },
    showDialogRoomModalForUpdate () {
      this.toggleCurrentDialogControls()
      this.showDialogRoomModal(this.currentDialog.id)
    },
    showDialogRoomModalForDelete () {
      this.toggleCurrentDialogControls()
      this.showDialogRoomModal(this.currentDialog.id)
    },
    setDialogRoomModalName (name) {
      this.$store.dispatch('setDialogRoomModalName', name)
    },
    setDialogRoomModalColor (color) {
      this.$store.dispatch('setDialogRoomModalColor', color)
    },
    addDialogRoomModalMember (user, isAdmin) {
      if (isAdmin) this.$store.commit('ADD_DIALOG_ROOM_MODAL_ADMIN', user)
      else this.$store.dispatch('addDialogRoomModalMember', user)
    },
    removeDialogRoomModalMember (user, isAdmin) {
      if (!isAdmin) this.$store.dispatch('removeDialogRoomModalMember', user)
      this.$store.commit('REMOVE_DIALOG_ROOM_MODAL_ADMIN', user)
    },
    clearDialogRoomModalValidation () {
      this.$store.commit('CLEAR_DIALOG_ROOM_MODAL_VALIDATION')
    },
    closeDialogRoomModal () {
      this.$store.dispatch('closeDialogRoomModal')
    },

    saveDialogRoomInfo () {
      this.$store.dispatch('saveDialogRoomInfo')
    },
    // /модалка комнаты чата

    // модалка истории сообщений
    showDialogHistoryModal () {
      this.$store.dispatch('showDialogHistoryModal')
    },
    closeDialogHistoryModal () {
      this.$store.commit('CLOSE_DIALOG_HISTORY_MODAL')
    },
    // /модалка истории сообщений

    // модалка закрепленного сообщения
    showPinnedModal () {
      this.$store.commit('SHOW_DIALOG_PINNED_MODAL')
    },
    closeDialogPinnedModal () {
      this.$store.commit('CLOSE_DIALOG_PINNED_MODAL')
    },
    // /модалка закрепленного сообщения

    getCompanionId (users) {
      return users.filter(user => user.id !== this.currentUser.id).pop().id
    },
    getDialogName (userId) {
      return this.$store.getters.getFullUserById(userId)?.name
    },
    getUserPosition (userId) {
      if (this.$store.getters.getFullUserById(userId)?.position) {
        return this.$store.getters.getFullUserById(userId).position.name
      } else {
        return ''
      }
    },
    getDialogAvatar (userId) {
      return this.$store.getters.getFullUserById(userId)?.avatar
    },
    getUserName (userId) {
      return this.$store.getters.getUserById({ userId })
    },
    dateBreakerText (date) {
      const compareDateA = new Date(currentDate())
      const compareDateB = new Date(date.slice(0, 10))
      // сравнение без преобразования к toDateString() всегда возвращала false
      return compareDateA.toDateString() === compareDateB.toDateString() ? 'Сегодня' : formatDate(date)
    },
    messageListHandleScroll () {
      // проверка на currentDialog нужна, иначе пагинация срабаьывает во время деактивации диалога
      if (this.currentDialog && !this.dialogRoomLoading && !this.currentDialog.messagesIsLoading && this.messagesWrap.elem.scrollTop === 0) {
        this.$store.dispatch('getDialogRoomMessageListNextPage')
        console.log('loading messages...')
      }
      // если пользователь проскролил к низу окна, тогда опираясь на dialogAutoScroll будет подскроливать к новому сообщению
      const clientHeight = this.messagesWrap.elem.clientHeight
      const scrollHeight = this.messagesWrap.elem.scrollHeight
      const scrollTop = this.messagesWrap.elem.scrollTop
      const isBottom = clientHeight === scrollHeight - scrollTop
      this.$store.commit('SET_DIALOG_MESSAGES_WRAP_AUTO_SCROLL', isBottom)
    },
    asideHandleScroll () {
      const isBlocked = this.dialogRoomList.userListPagination.isBlocked
      const nextPage = this.dialogRoomList.userListPagination.currentPage + 1
      const scrollHeight = this.asideBody.scrollHeight
      const scrollTop = this.asideBody.scrollTop
      const clientHeight = this.asideBody.clientHeight

      if (!isBlocked && (scrollHeight - scrollTop === clientHeight)) {
        this.$store.dispatch('getDialogUserList', nextPage)
        console.log('loading contacts... page:', nextPage)
      }
    },
    checkResend () {
      if (this.selectResendUserMode) {
        this.selectResendUserMode = false
        this.resend()
      } else if (!this.selectResendUserMode) {
        this.clearResend()
      }
    },
    getUserAvatar (userId) {
      if (this.$store.getters['[dictionaries] usersList']?.length) {
        if (this.$store.getters.getFullUserById(userId)) {
          return this.$store.getters.getFullUserById(userId).avatar
        } else {
          return false
        }
      }
    },
    openUsersModals () {
      this.usersGroupModal = true
      this.$nextTick(() => {
        this.$refs.usersGroupModal.focus()
      })
    },
    handleBlur (event) {
      const enteringParent = !this.$refs.usersGroupModal?.contains(event.relatedTarget)

      if (enteringParent) {
        this.usersGroupModal = false
        this.userGroupSearch = ''
      }
    }
  },
  watch: {
    // нужно оставлять скрол на месте откуда началась подгрузка новых сообщений, иначе элемент скролится к верху
    dialogNextPageIsLoading (newFlag) {
      if (newFlag) {
        this.messagesWrap.scrollHeightA = this.messagesWrap.elem.scrollHeight
      } else {
        // таймаут нужен для того чтобы высота элемента успела изменится
        setTimeout(() => {
          this.messagesWrap.scrollHeightB = this.messagesWrap.elem.scrollHeight
          this.messagesWrap.elem.scrollTop = this.messagesWrap.scrollHeightB - this.messagesWrap.scrollHeightA
        }, 0)
      }
    },
    messages () {
      this.$store.dispatch('setDialogMessageListIsRead')
    },
    'selectedMessages.length' (val) {
      this.selectMode = !!val
    },
    'currentDialog.id' () {
      this.checkResend()
      this.userGroupList = this.currentDialog?.users || []
      this.$store.commit('SET_DIALOG_MESSAGES_WRAP_AUTO_SCROLL', true)
    },
    'currentDialog.users' (val) {
      this.userGroupList = val
    },
    userGroupSearch (val) {
      if (val) {
        this.userGroupList = this.currentDialog?.users?.filter(user => {
          const userName = this.getUserName(user.id)?.toLowerCase()
          const searchVal = val.toLowerCase()
          return userName.includes(searchVal)
        })
      } else {
        this.userGroupList = this.currentDialog?.users
      }
    },
    '$route' () {
      this.closeDialogWidget()
    }
  },
  updated () {
    // нужно держать обертку чата всегда прокрученной вниз
    if (this.dialogAutoScroll) {
      this.messagesWrap.elem.scrollTop = this.messagesWrap.elem.scrollHeight
    }
  },
  mounted () {
    this.$store.dispatch('getDialogUserList')
    this.asideBody = this.$refs.aside_body
    // нужно держать обертку чата всегда прокрученной вниз
    this.messagesWrap.elem = this.$refs.messages_wrap
    this.messagesWrap.elem.scrollTop = this.messagesWrap.elem.scrollHeight

    this.messagesWrap.elem.addEventListener('scroll', this.messageListHandleScroll)
    this.asideBody.addEventListener('scroll', this.asideHandleScroll)

    this.userGroupList = this.currentDialog?.users || []
  },
  beforeDestroy () {
    // чтобы небыло бага когда поиск применен, но поле поиска пустое, обнуляем при закрытии чата
    this.$store.dispatch('setDialogListSearchValue', '')
    // сбрасываем пагинацию чтобы контакты подкгружались с первой страницы
    this.$store.commit('RESET_DIALOG_WIDGET_USER_LIST_CURRENT_PAGE')
  }
}
</script>

<style lang="scss">
.attachment-preview {
  font-size: 14px;
}
</style>

<style lang="scss" scoped>
@import '../../../assets/css/system/vars';
@import '../../../assets/css/system/mixins';

.widget {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  background: $color_main;

  @media screen and (max-width: $tablet_start) {
    position: relative;
    width: 100%;
    flex-direction: column-reverse;
    overflow: auto;
  }
}

.aside {
  display: flex;
  flex-flow: column nowrap;
  width: 280px;
  background: $color_sixth;

  @media screen and (max-width: $desktop-sm_start) {
    width: 240px;
  }

  @media screen and (max-width: $tablet_start) {
    position: absolute;
    z-index: 10000;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    transition: .5s;

    &.slide-out {
      transform: translateX(-100%);
    }
  }

  &__close-dialog {
    padding: 8px 20px 8px 0;
    @include size(40px);
    margin-left: auto;
    color: $font_color_third;
  }

  &__head {
    padding: 18px 20px 0 20px;
    margin-bottom: 20px;
  }

  &__body {
    position: relative;
    flex: 1;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: $color_third;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color_second-light;
    }
  }

  &__bottom {
    position: relative;
    border-top: 1px solid $border_color;
    padding: 20px 26px 26px 26px;
  }
}

.create-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 3px;
  font-size: 14px;
  color: $font_color_alt;
  background: $button_color_fourth;
  box-shadow: 0 2px 2px #527225;
  transition: .3s;
  cursor: pointer;

  &__icon {
    display: inline-block;
    margin-right: 8px;
  }

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0 4px 4px #527225;
  }
}

.body {
  display: flex;
  flex-flow: column nowrap;
  width: 640px;
  background: $color_main;

  @media screen and (max-width: $desktop-sm_start) {
    width: 540px;
  }

  @media screen and (max-width: $tablet_start) {
    width: 100%;
    height: 100%;
  }
}

.head {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  border-bottom: 1px solid $border_color;
  padding: 8px 8px 8px 18px;

  @media screen and (max-width: $tablet_start) {
    font-size: 14px;
    padding: 8px 8px 8px 0;
  }

  &__close-dialog {
    padding-right: 16px;
    padding-left: 10px;
    color: $font_color_third;

    .arrow-prev-icon {
      width: 26px;
      height: 25px;
    }
  }
}

.dialog {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  &__avatar {
    @include size(36px);
    margin-right: 10px;
  }

  &__name {
    color: $font_color_third;
    width: 100%;
    max-width: 230px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;

    @media screen and (max-width: $tablet_start) {
      max-width: 180px;
    }
  }

  &__position {
    color: $font_color_second;
    width: 100%;
    max-width: 230px;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media screen and (max-width: $tablet_start) {
      max-width: 180px;
    }
  }

  &__info {
    position: relative;

    .dialog__members-modal {
      position: absolute;
      z-index: 100;
      background: white;
      width: 299px;
      border-radius: 3px;
      padding: 18px 17px 20px;
      filter: drop-shadow(0px 4px 20px rgba(23, 63, 125, 0.22));

      .users {
        display: flex;
        flex-direction: column;
        height: 100%;
        max-height: 230px;
        width: 100%;
        overflow: auto;
        margin-top: 20px;

        &::-webkit-scrollbar {
          width: 8px;
          height: 10px;
        }

        &::-webkit-scrollbar-track {
          background-color: $color_third;
        }

        &::-webkit-scrollbar-thumb {
          background-color: $color_second-light;
          min-width: 300px;
        }

        .users__item {
          display: flex;
          align-items: center;
          color: $font_color_third;
          width: 100%;
          padding: 0 5px;
          min-height: 40px;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: bold;
          cursor: pointer;

          &:not(:first-of-type) {
            margin-top: 18px;
          }
        }
      }
    }
  }

  &__members {
    color: $font_color_second;
    font-size: 12px;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      text-decoration: underline;
    }

  }

  &__group-avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    &__icon {
      color: $color_main;
      transform: translate(0, -1px);
    }
  }
}

.dialog-controls {
  display: flex;
  flex-flow: row nowrap;
  margin-left: auto;

  &__item {
    display: flex;
    justify-content: center;
    width: 28px;
    height: 28px;
    color: #95A4C0;
    cursor: pointer;
    user-select: none;
    margin-right: 16px;
    transition: .3s;

    &.active {
      color: $color_second-light;
    }

    @media screen and (min-width: $hover_enable_width) {
      &:hover {
        color: $color_second-light;
      }
    }
  }
}

.invite {}

.history {
  margin-right: 8px;
}

.resend {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 160px;
    color: #0E619F;
    font-weight: bold;
    border: 1px solid #0E619F;
    border-radius: 3px;
    padding: 0px 15px 0px 15px;
    transition: .3s;
    cursor: pointer;
    background: none;
    margin-right: 10px;

    &:hover {
      color: white;
      background: #0E619F;
    }
}

.menu {
  position: relative;

  &__popup {
    position: absolute;
    z-index: 999;
    top: 36px;
    right: -8px;

    .popup-menu:before {
      top: -6px;
      right: 15px;
      transform: rotate(45deg);
    }
  }
}

.date {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  color: $color_second;
  margin-top: 10px;
  margin-left: 16px;
  margin-bottom: 10px;

  &__h {
    position: relative;
    z-index: 2;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    width: 108px;
    height: 20px;
    font-size: 14px;
    background: $color_main;
  }

  &:before {
    content: '';
    position: absolute;
    top: auto;
    left: 0;
    bottom: auto;
    z-index: 1;
    width: 100%;
    height: 1px;
    background: rgba(23, 63, 125, 0.22);
  }
}

.pinned {
  display: flex;
  flex-flow: column;
  height: 105px;
  width: 100%;
  background-color: $color_main;
  border-bottom: 1px solid $border_color;
  box-shadow: 0 1px 1px rgba(17, 112, 184, 0.25);

  @media screen and (max-width: $tablet_start) {
    height: auto;
  }

  &__title {
    display: flex;
    flex-flow: row nowrap;
    font-weight: bold;
    color: #C01082;
    padding: 10px 20px 0;

    @media screen and (max-width: $tablet_start) {
      position: relative;
      padding: 10px 40px 14px 10px;
      font-size: 14px;
    }
  }

  &__icon {
    margin-right: 4px;
  }

  &__unpin {
    color: $color_deactive-second;
    transition: .3s;
    margin-left: auto;
    cursor: pointer;
    user-select: none;

    @media screen and (max-width: $tablet_start) {
      position: absolute;
      top: 0;
      left: auto;
      right: 0;
      padding: 12px;
    }

    @media screen and (min-width: $hover_enable_width) {
      &:hover {
        color: $color_second-light;
      }
    }
  }

  &__row {
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
    padding: 8px 20px 8px;
    overflow: hidden;
    cursor: pointer;
    transition: .3s;

    &:hover {
      background: $color_sixth;
    }

    @media screen and (max-width: $tablet_start) {
      display: none;
    }
  }

  &__files {
    width: 40px;
    height: 50px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    border-radius: 3px;
    background-color: #D0E7F7;
    color: $color_second-light;
  }

  &__text {
    flex: 1;
    color: $font_color_second;
    font-size: 14px;
    line-height: 1.25;

    .plain-html a:hover {
      color: $color_second-light;
    }
  }
}

.messages-wrap {
  flex: 1;
  position: relative;
  display: flex;
  flex-flow: column;
  overflow: auto;
  padding-top: 90px;
  padding-bottom: 10px;
  margin-right: 16px;

  @media screen and (max-width: $tablet_start) {
    margin-right: 0;
  }

  &__preloader {
    position: absolute;
    top: 16px;
    left: 0;
    right: 0;
    margin: auto;
    @include size(36px);

    @media screen and (max-width: $tablet_start) {
      left: 10px;
    }
  }

  &__no-records {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-button {
    height: 4px;
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: $color_main;
    /*background-color: $color_third;*/
  }

  &::-webkit-scrollbar-thumb {
    background: transparentize($color_second-light, .7);
    border-radius: 3px;
    /*background-color: $color_second-light;*/
  }
}

.message-list {
  margin-top: auto;

  &__item {
    width: 100%;
  }
}

.message-area-wrap {
  padding: 0 20px 20px;
}

.message-area-info {
  font-size: 12px;
}

.message-area-error {
  height: 18px;
  color: $color_error;
  font-size: 14px;

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  &__icon {
    margin-right: 8px;
  }

  &__message {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.who-prints {
  height: 18px;
  color: $color_second;

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  &__icon {
    display: flex;
    flex-flow: row nowrap;
    margin-left: 4px;
    transform: translateY(2px);

    .dot {
      display: block;
      @include size(3px);
      border-radius: 50%;
      background: currentColor;
      margin-right: 4px;
      transform-origin: center;
      transition: .3s;
      animation: printingDots 1.2s linear infinite;

      &:nth-child(2) {
        animation-delay: .2s;
      }

      &:last-child {
        animation-delay: .4s;
        margin-right: 0;
      }
    }
  }
}

.message-area {
  border: 1px solid $border_color;
  background: $color_main;
  border-radius: 3px;

  @media screen and (max-width: $tablet_start) {
    padding-top: 6px;
    padding-bottom: 8px;
  }

  &__input {
    /*ширину инпута пришлось задать статично, потому что при наборе текста без переноса ширина увеличивается и ломает верстку*/
    width: 430px;

    @media screen and (max-width: $desktop-sm_start) {
      width: 330px;
    }

    @media screen and (max-width: $tablet_start) {
      width: 100%;
      max-width: unset;
    }

    max-height: 200px;
    overflow: auto;

    .message-area__input-resend {
      color: $font_color_second;
      margin-left: 16px;
      padding-left: 16px;
      border-left: 3px solid $font_color_third;
      position: relative;

      b {
        color: $font_color_third;
      }

      .resend-clear {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
      }
    }
  }

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 10px 14px 10px;
  }

  &__buttons {
    display: flex;
    flex-flow: row nowrap;
    margin-left: auto;
  }

  &__cancel-button {
    margin-right: 8px;
    cursor: pointer;
    user-select: none;
    transition: .3s;
    color: $color_deactive-second;

    @media screen and (min-width: $hover_enable_width) {
      &:hover {
        color: $color-second-light;
      }
    }
  }

  &__send-button {
    padding: 0;
    cursor: pointer;
    user-select: none;
    transition: .3s;
    color: $color_second-light;

    &[disabled] {
      color: #CBCBCB;
      cursor: not-allowed;

      &:hover {
        color: #CBCBCB;
      }
    }

    @media screen and (min-width: $hover_enable_width) {
      &:hover {
        color: $color_second-dark;
      }
    }
  }

  &__attachment-preview {
    background: $color_main;
    padding: 10px 14px 0;
  }
}

.reply-wrap {
  padding: 10px 16px 0;
}

.replied-to {
  color: $color_second-light;

  &__close {
    color: $font_color_second;
    transition: .3s;
    cursor: pointer;

    &:hover {
      color: $color_second-light;
    }
  }
}

.quote {
  padding-left: 16px;
  font-size: .8em;
  font-weight: 300;
  font-style: italic;
  color: $font_color_second;
}
</style>
